function lightboxify(parent) {
  parent.querySelectorAll("img").forEach(function (img, index) {
    var link = document.createElement("a");
    link.href = img.src;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    img.parentNode.insertBefore(link, img);
    link.appendChild(img);

    // Skip if the browser doesn't support popovers
    if (!HTMLElement.prototype.hasOwnProperty("popover")) {
      return;
    }

    var popover = document.createElement("div");
    popover.popover = "auto";
    popover.id = `image-popover-${index}`;
    popover.classList.add(
      "backdrop:bg-black/50",
      "backdrop:backdrop-blur-lg",
      "w-fit",
      "h-fit",
    );

    var imgElement = document.createElement("img");
    imgElement.src = img.src;
    imgElement.classList.add("max-h-screen");
    imgElement.addEventListener("click", function () {
      popover.hidePopover();
    });
    popover.appendChild(imgElement);

    var closeButton = document.createElement("button");
    closeButton.textContent = "\u2715";
    closeButton.classList.add("fixed", "top-0", "right-0", "p-4");
    closeButton.addEventListener("click", function () {
      popover.hidePopover();
    });
    popover.appendChild(closeButton);

    document.body.appendChild(popover);

    link.addEventListener("click", function (e) {
      if (!e.ctrlKey && !e.metaKey && !e.shiftKey) {
        e.preventDefault();
        popover.showPopover();
      }
    });
  });
}

export function setup() {
  document.querySelectorAll("[data-lightboxify]").forEach(function (element) {
    lightboxify(element);
  });
}
